
  var _styles = {
  "max-demo-title": {
    "fontFamily": "Arial",
    "fontSize": "0.6rem",
    "fontWeight": "bold",
    "padding": "0.53333rem",
    "display": "flex",
    "backgroundColor": "rgb(10,29,86)",
    "color": "rgb(253,231,103)"
  },
  "max-demo-desc": {
    "paddingTop": "0.26667rem",
    "paddingRight": "0.53333rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.53333rem",
    "fontSize": "0.32rem",
    "backgroundColor": "rgb(201,215,221)",
    "color": "rgb(99,122,159)"
  }
};



  module.exports = _styles;
  